import { handleCellRenderer as clientCellRenderer } from "app/shared/AgTable/AgUtility";
import { handleCellRenderer } from "app/shared/AgTable/AgServerUtility";
import { Mixpanel } from "app/config/Mixpanel";

const openSidebarRenderer = (params: any) => {
  params.api.openToolPanel("pdfRenderer", { paramData: params });
};
export const getProcessedDefinition = (
  columnArray: any[],
  type: "SERVER" | "CLIENT" = "SERVER",
  pdfFunction: (data: any) => void,
  userMeta: any = {}
) => {
  // Common Excel Style
  const commonExcelStyle = {
    id: "headerStyle1",
    font: {
      bold: true,
      color: { rgb: "FF0000" }, // Red color
    },
    alignment: {
      horizontal: "Center",
      vertical: "Center",
    },
    fill: {
      fgColor: { rgb: "D3D3D3" }, // Gray background color
    },
  };
  // Helper function to add cellRendererParams
  const addCellRendererParams = (columnData: any) => {
    if (columnData.formatType === "INVOICE") {
      return {
        ...columnData,
        cellRendererParams: () => ({
          label: "View Invoice",
          handleClick: (params: any) => {
            pdfFunction(params.data?.[columnData.field]);
            openSidebarRenderer(params);
          },
        }),
      };
    }
    // if (columnData.formatType === "DATE") {
    //   return {
    //     ...columnData,
    //     filterParams: {
    //       comparator: (filterDate: any, cellValue: any) => {
    //         if (!cellValue) return -1; // Treat empty cells as before the filter date.

    //         // Convert cellValue to a Date object
    //         const cellDate = new Date(cellValue);
    //         // Remove the time portion from both dates
    //         const filterDateOnly = new Date(filterDate.toDateString());
    //         const cellDateOnly = new Date(cellDate.toDateString());

    //         // Compare the dates
    //         if (cellDateOnly < filterDateOnly) return -1; // Cell date is before filter date
    //         if (cellDateOnly > filterDateOnly) return 1; // Cell date is after filter date
    //         return 0; // Dates are equal
    //       },
    //     },
    //   };
    // }
    if (columnData.formatType === "DATE") {
      return {
        ...columnData,
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterDate: any, cellValue: any) => {
            if (!cellValue) return -1;

            let cellDate: Date | null = null;

            // ✅ Smart format detection and conversion
            if (typeof cellValue === "string") {
              if (cellValue.includes(" ")) {
                // Format: "yyyy-mm-dd HH:mm:ss.SSS"
                const isoString = cellValue.replace(" ", "T");
                cellDate = new Date(isoString);
              } else if (/^\d{2}-\d{2}-\d{4}$/.test(cellValue)) {
                // Format: "dd-mm-yyyy"
                const [dd, mm, yyyy] = cellValue.split("-");
                cellDate = new Date(`${yyyy}-${mm}-${dd}`);
              } else {
                // Likely ISO format like "yyyy-mm-dd"
                cellDate = new Date(cellValue);
              }
            } else if (cellValue instanceof Date) {
              cellDate = cellValue;
            }

            // ❌ Invalid date
            if (!cellDate || isNaN(cellDate.getTime())) {
              console.warn("❌ Invalid date parsed:", cellValue);
              return -1;
            }

            // ⏰ Normalize times to 00:00
            const filterDateOnly = new Date(
              filterDate.getFullYear(),
              filterDate.getMonth(),
              filterDate.getDate()
            );
            const cellDateOnly = new Date(
              cellDate.getFullYear(),
              cellDate.getMonth(),
              cellDate.getDate()
            );

            // 🔁 Compare
            if (cellDateOnly < filterDateOnly) return -1;
            if (cellDateOnly > filterDateOnly) return 1;
            return 0;
          },
        },
      };
    }

    return columnData;
  };

  // Recursive processing of columns
//   const processColumns: any = (columns: any[]) =>
//     columns
//       .map((columnData: any) => {
//         // Hide logic
//         // console.log(
//         //   "userMeta:",
//         //   userMeta,
//         //   columnData.hide === "CORPORATE" &&
//         //     (userMeta.account_type === "CLIENT" ||
//         //       userMeta.currentWorkspace.role === "GENERAL")
//         // );
//         const updatedColumn = {
//           ...columnData,
//         };
//         if (
//           columnData.hide === "CORPORATE" &&
//           (userMeta.account_type === "CLIENT" ||
//             userMeta.currentWorkspace.role === "GENERAL")
//         ) {
//           return null;
//         } else {
//           updatedColumn.hide = false;
//         }

//         // Add cellRendererParams
//         const columnWithRendererParams = addCellRendererParams(updatedColumn);

//         // Process children if present
//         if (columnWithRendererParams.children?.length > 0) {
//           return {
//             ...columnWithRendererParams,
//             children: processColumns(columnWithRendererParams.children),
//           };
//         }

//         return {
//           ...columnWithRendererParams,
//           excelStyle: commonExcelStyle,
//           ...(type === "SERVER" ? handleCellRenderer() : clientCellRenderer()), // Server or client-specific logic
//         };
//       })
//       .filter((column) => column !== null); // Remove null columns

//   return processColumns(columnArray);
// };
const processColumns: any = (columns: any[]) =>
  columns
    .map((columnData: any) => {
      const updatedColumn = { ...columnData };

      // Safe hide logic - check both hide and hide_column properties
      const userRole = userMeta.currentWorkspace?.role; // safe access
      // Support both formats: hide (from columnDefs) and hide_column (from flat array)
      const hideValue = columnData.hide_column !== undefined 
        ? columnData.hide_column 
        : columnData.hide;
      
      // Handle boolean hide (AG Grid format)
      if (hideValue === true) {
        return null; // hide this column
      }
      
      // Handle string-based hide values
      if (
        hideValue === "CORPORATE" &&
        (userMeta.account_type === "CLIENT" || userRole === "GENERAL")
      ) {
        return null; // hide this column for CLIENT or GENERAL users
      } else if (hideValue === "All") {
        // Hide column for all users if hide_column is "All"
        return null;
      } else {
        updatedColumn.hide = false;
      }

      // Add cellRendererParams
      const columnWithRendererParams = addCellRendererParams(updatedColumn);

      // Process children recursively if present
      if (columnWithRendererParams.children?.length > 0) {
        return {
          ...columnWithRendererParams,
          children: processColumns(columnWithRendererParams.children),
        };
      }

      return {
        ...columnWithRendererParams,
        excelStyle: commonExcelStyle,
        ...(type === "SERVER" ? handleCellRenderer() : clientCellRenderer()),
      };
    })
    .filter((column) => column !== null); // Remove null columns

return processColumns(columnArray);
  };


export const getSubdomain = () => {
  const { hostname } = window.location; // Get the hostname (e.g., sub.domain.com)
  const parts = hostname.split("."); // Split the hostname into parts (e.g., ['sub', 'domain', 'com'])

  if (parts.length > 2) {
    // If there are more than two parts, the first part is the subdomain
    return parts[0];
  } else {
    // No subdomain exists
    return "app";
  }
};

export const downloadSampelCrendentialCSV = async () => {
  Mixpanel.track("User Downloaded Sample Credential CSV", {
    Screen: "Integration",
  });

  let csvString = `gstin,username,password
                    09AABCG3241G1ZL,testuser1,user_password
                    09AABCG3141G1ZL,testuser2,user_password
                    09AABCG8111G1ZL,testuser3,user_password`;
  try {
    // Convert the CSV string to a Blob
    const csvBlob = new Blob([csvString], { type: "text/csv" });

    // Convert the Blob object to a data URL
    const csvDataUrl = URL.createObjectURL(csvBlob);

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = csvDataUrl;
    link.setAttribute("download", "sample_credentials.csv");

    // Trigger the download by programmatically clicking the anchor element
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading CSV file:", error);
  }
};
